<div *ngIf="data && data.length > 0" class="container">
    <div *ngFor="let item of data" class="row">
        <h2>{{"Managers of" | translator}} {{item.name}}</h2>

        <div class="gap-2 d-flex align-items-center font-medium my-2" style="flex-wrap: wrap; list-style: none !important;">

            <div *ngFor="let crumb of item.breadcrumbs; let i=index" class="d-flex flex-nowrap align-items-center text-nowrap">
                <i *ngIf="i != 0" class="pi pi-angle-left directory-icone"></i>
                <img
                    *ngIf="checkIsImage(crumb.icon); else elseBlock"
                    src="{{ staticFileUrl + crumb.icon }}"
                    class="mx-2"
                    style="max-width: 20px; max-height: 20px;"
                />
                <ng-template #elseBlock>
                    <i class="{{ crumb.icon }} mx-2" style="font-size: 1rem"></i>
                </ng-template>
                <div class="me-4">{{crumb.label}}</div>
                
            </div>

            <div  class="d-flex flex-nowrap align-items-center text-nowrap">
                <i class="pi pi-angle-left directory-icone"></i>

                <img
                    *ngIf="checkIsImage(item.image); else elseBlock"
                    src="{{ staticFileUrl + item.image }}"
                    class="mx-2"
                    style="max-width: 20px; max-height: 20px;"
                />
                <ng-template #elseBlock>
                    <i class="{{ item.image }} mx-2" style="font-size: 1rem"></i>
                </ng-template>

                <div class="me-4">{{item.name}}</div>
            </div>
        </div>
        
        <div *ngIf="item.managers && item.managers.length > 0" class="col-7">

            
            <div class="row">
                <div class="col p-2">
                    <div class="card assess-card">
                        <!-- <h5 class="p-2">{{"Managers" | translator}}</h5> -->

                        <table class="table">
                            <thead>
                                <tr>
                                    <th colspan="1">{{"user name" | translator}}</th>
                                    <th colspan="1">{{"Email" | translator}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of item.managers">
                                    <td> {{item.name.first}} {{item.name.middle}} {{item.name.last}}</td>
                                    <td>{{item.email}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>